import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Status, Version } from '../../../model/changelogs/changelogs';
import {
  APIUrls,
  WebConfigurationService,
} from '../common/web-configuration.service';

@Injectable({
  providedIn: 'root',
})
export class ChangelogsService extends WebConfigurationService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  /**
   * GET Status datas
   */
  public getStatusData(): Observable<Status[]> {
    return this.authGetObs<Status[]>(APIUrls.getStatusUrl());
  }

  /**
   * GET Status datas
   */
  public getApiVersion(): Observable<Version[]> {
    return this.authGetObs<Version[]>(APIUrls.getApiVersionUrl());
  }
}
